import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

/**
 * @function
 * @name Status
 * @param {Boolean} isOnline - whether the user is online
 * @param {Integer} userId - the user's id
 * @param {Boolean} isOnVacation - whether the user is out of office
 * Returns the markup of the online indicator
 */

const Status = ({isOnline, userId, isOnVacation}) => {
    if (!isOnVacation) {
        return (<span className={`user-online-indicator ${isOnline ? 'is-online ' : ''}`} data-user-id={userId}><i className="fa fa-circle"></i>{i18n.t('general.online')}</span>);
    }

    return (<span className="user-ooo-indicator" data-user-id={userId}>{i18n.t('seller_card.out_of_office')}</span>);
};

Status.propTypes = {
    isOnVacation: PropTypes.bool.isRequired,
    isOnline: PropTypes.bool,
    userId: PropTypes.number
};

export default Status;


// WEBPACK FOOTER //
// ./src/components/status/index.js